export enum AdminPaymentMethodListItemAction {
  Edit,
  Preview,
}
